var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { create } from "zustand";
export const useAutomationsModal = create((set, get) => ({
    open: false,
    setOpen: (op) => set({ open: op }),
    selectedAutomation: null,
    saveAutomation: () => __awaiter(void 0, void 0, void 0, function* () {
    }),
    setSelectedAutomation: (updatedAutomation) => {
        if (updatedAutomation === null)
            return set({ selectedAutomation: null });
        let automation = get().selectedAutomation;
        set({
            // @ts-ignore
            selectedAutomation: Object.assign(Object.assign({}, automation), updatedAutomation)
        });
    }
}));
//# sourceMappingURL=useAutomationsModal.js.map